import React from 'react';

const NorbertTestComponent = () => {
  return <h1>This is Norbert&#39;s test.</h1>;
};

export default NorbertTestComponent;
